import { OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/platform-browser";
var RouterEventService = /** @class */ (function () {
    function RouterEventService(router, titleService) {
        this.router = router;
        this.titleService = titleService;
        this.subscriptions = new Subscription();
    }
    RouterEventService.prototype.ngOnDestroy = function () {
        this.subscriptions.unsubscribe();
    };
    // 返信一覧表示判定。対象ユーザーが遷移しようとした際、案件一覧へリダイレクト
    RouterEventService.prototype.redirectTargetUserToTop = function () {
        var restrictedUserCodes = ['sales.all.technocore', 'sales.all.accessnet', 'sales.all.infinius'];
        var account = JSON.parse(localStorage.getItem('account'));
        if (account && restrictedUserCodes.includes(account.user_code)) {
            this.router.navigate(['/projects']);
            return true;
        }
        return false;
    };
    RouterEventService.prototype.changeTabName = function () {
        var _this = this;
        var changeTabNameSub = this.router.events.subscribe(function (nav) {
            if (nav instanceof NavigationEnd) {
                if (nav.url.match(/login/)) {
                    _this.titleService.setTitle(_this.createTabName('ログイン'));
                }
                else if (nav.url.match(/matching\/projects/)) {
                    if (nav.url.match(/matching\/projects\//)) {
                        _this.titleService.setTitle(_this.createTabName('案件詳細'));
                    }
                    else {
                        _this.titleService.setTitle(_this.createTabName('案件一覧'));
                    }
                }
                else if (nav.url.match(/matching\/workers/)) {
                    if (nav.url.match(/matching\/workers\//)) {
                        _this.titleService.setTitle(_this.createTabName('人材詳細'));
                    }
                    else {
                        _this.titleService.setTitle(_this.createTabName('人材一覧'));
                    }
                }
                else if (nav.url.match(/replies/)) {
                    // 特定のuser_codeの場合はリダイレクト
                    if (_this.redirectTargetUserToTop()) {
                        return;
                    }
                    _this.titleService.setTitle(_this.createTabName('返信一覧'));
                }
                else if (nav.url.match(/matching\/auto/)) {
                    _this.titleService.setTitle(_this.createTabName('おすすめ'));
                }
                else if (nav.url.match(/offer/)) {
                    _this.titleService.setTitle(_this.createTabName('提案管理'));
                }
                else if (nav.url.match(/mail-register/)) {
                    _this.titleService.setTitle(_this.createTabName('案件人材管理'));
                }
                else if (nav.url.match(/report/)) {
                    _this.titleService.setTitle(_this.createTabName('レポート(β)'));
                }
                else if (nav.url.match(/account\/setting/)) {
                    _this.titleService.setTitle(_this.createTabName('設定'));
                }
                else if (nav.url.match(/registration/)) {
                    _this.titleService.setTitle(_this.createTabName('ユーザー登録'));
                }
                else if (nav.url.match(/account\/setting\/notification/)) {
                    _this.titleService.setTitle(_this.createTabName('通知設定'));
                }
                else if (nav.url.match(/account\/setting\/matching-condition/)) {
                    _this.titleService.setTitle(_this.createTabName('マッチング条件設定'));
                }
                else if (nav.url.match(/account\/setting\/business/)) {
                    _this.titleService.setTitle(_this.createTabName('BP設定'));
                }
                else if (nav.url.match(/account\/password\/change/)) {
                    _this.titleService.setTitle(_this.createTabName('パスワード変更'));
                }
                else if (nav.url.match(/account\/password\/reset\/mail/)) {
                    _this.titleService.setTitle(_this.createTabName('パスワード再発行'));
                }
                else if (nav.url.match(/privacy-policy-component/)) {
                    _this.titleService.setTitle(_this.createTabName('プライバシーポリシー'));
                }
                else if (nav.url.match(/terms-of-service/)) {
                    _this.titleService.setTitle(_this.createTabName('利用規約'));
                }
            }
        });
        this.subscriptions.add(changeTabNameSub);
    };
    RouterEventService.prototype.createTabName = function (page) {
        return page + " \uFF5C Qoala";
    };
    RouterEventService.ngInjectableDef = i0.defineInjectable({ factory: function RouterEventService_Factory() { return new RouterEventService(i0.inject(i1.Router), i0.inject(i2.Title)); }, token: RouterEventService, providedIn: "root" });
    return RouterEventService;
}());
export { RouterEventService };
